import { ApiStateGlobal, ApiStateRequestType } from './api-status.enum';

export enum DocumentTypes {
  SASB = 'SASB',
  ESRS = 'ESRS',
  CSRD = 'CSRD',
  GRI = 'GRI',
  TCFD = 'TCFD',
}

export enum ReportNames {
DEAL_TRACKING = 'af0f9792-7127-4be1-b506-fda6d9f9de22',
COMMAND_CENTER = 'bd9d13ab-df49-4ab3-965a-977bfcbd307c',
RESOURCE_FORECASTING = 'f0bca476-8c30-47db-a063-e41a6e8f7bb9',
TRANSFORMATION = '8973a9f0-6ec1-499f-9364-3f1a022a8b65',
TRANSITION = 'bf6b1cbd-c814-4910-9fe5-318df55d3d61',
}

export enum HomeApiStateKeyNames {
  DASHBOARD_DETAILS = 'DASHBOARD_DETAILS',
}

export type HomeApiStates =
  | {
      [HomeApiStateKeyNames.DASHBOARD_DETAILS]: Record<
        ApiStateRequestType,
        boolean
      >;
    }
  | ApiStateGlobal;
